import { render } from "./UnassignedDevices.vue?vue&type=template&id=4fab26f2"
import script from "./UnassignedDevices.vue?vue&type=script&lang=js"
export * from "./UnassignedDevices.vue?vue&type=script&lang=js"

import "./UnassignedDevices.vue?vue&type=style&index=0&id=4fab26f2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__